import LanguageService from '@services/language-service'
import { getLocale, setLocale } from '@utils/user-info.js'
import { DEFAULT_LANGUAGE } from '@constants/translations.js'
import Vue from 'vue'

export const state = {
    appLanguage: getLocale() || setLang(),
    languages: [],
}

function setLang(){
    setLocale(DEFAULT_LANGUAGE);
    return DEFAULT_LANGUAGE
}

export const mutations = {
    SET_LANGUAGES(state, { items }) {
        state.languages = items
    },
    SET_APP_LANGUAGE(state, { appLanguage }) {
        state.appLanguage = appLanguage
        Vue.prototype._i18n.locale = appLanguage
        setLocale(appLanguage)
    },
}

export const getters = {
    languages(state) {
        return state.languages
    },
    appLanguage(state) {
        return state.appLanguage
    },
}

export const actions = {
    // This is automatically run in `src/state/store.js` when the app
    // starts, along with any other actions named `init` in other modules.
    async init({ dispatch }) {
        const { items } = await LanguageService.getLanguages({
            params: {
                // TODO ask BE regarding pageSize 10000
                pageSize: 10000,
            },
        })

        dispatch('setLanguages', {
            items,
        })
    },

    setLanguages({ commit }, payload) {
        commit('SET_LANGUAGES', payload)
    },

    setAppLanguage({ commit }, payload) {
        commit('SET_APP_LANGUAGE', payload)
    },
}
